

import React, { useState } from 'react';
import styles from '../../assets/scss/Billing/Billingtable.module.scss';
import Pagination from '../../Components/Common/Pagination';
import { FaChevronUp, FaChevronDown, FaEye, FaPrint } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import ReceivedBills from './ReceivedBills';
import MyBilling from './MyBilling';
import DatePicker from 'react-datepicker';
import { useGetPayableBillsQuery } from '../../slices/admin/admin';
import { getUserInfo } from '../../utils/user.util';
import InvoiceDesign from './InvoiceDesign';
import PopupWrapper from '../../Components/Common/PopupWrapper';
import PayableInvoiceDesign from './PayableInvoiceDesign';
import TransportHandlersBilling from '../TransportHandlers/TransportHandlersBilling';
import AssetTable from './AssetCount/AssetTable';
import { capitalize } from '../../utils/capitalize';

const Billing = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [showStats, setShowStats] = useState(false);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [search, setSearch] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [status, setStatus] = useState('');
  const user = getUserInfo();
  const location = useLocation();
  const billingPermission = user?.roles
    ?.flatMap(r => r.permissions)
    ?.find(p => p.functionality === "billing");

  const isFullAccess = billingPermission?.permissionType === "fullaccess";
  // const isViewOnly = billingPermission?.permissionType === "view only";

  const [activeTab, setActiveTab] = useState(() => {
    if (location.state?.activeTab) {
      return location.state.activeTab;
    }
    if (isFullAccess) return "received";
    return "mybilling";
  });

  const navigate = useNavigate();
  const offset = currentPage;

  const { data: payableData, isLoading } = useGetPayableBillsQuery({
    fromDate,
    toDate,
    search,
    paymentMethod,
    status,
    offset,
    limit,
  });

  console.log(payableData, "payableData in billing");


  const totalPages = payableData ? Math.ceil(payableData.totalCount / limit) : 1;

  const [receivedStats, setReceivedStats] = useState({
    total: 0,
    totalReceivedAmount: 0,
    totalPendingAmount: 0,
  });

  const [myBillingStats, setMyBillingStats] = useState({
    totalBills: 0,
    collected: 0,
    remaining: 0,
  });


  // print code start
  const [showPrintPopup, setShowPrintPopup] = useState(false);
  const [activeTabs, setActiveTabs] = useState("thermal");
  const [selectedBill, setSelectedBill] = useState(null);
  // print code end

  const clearFilters = () => {
    setFromDate(null);
    setToDate(null);
    setSearch('');
    setPaymentMethod('');
    setStatus('');
  };

  return (
    <div className={styles.dashboard}>
      {/* Tabs */}
      <div className={styles.tabs}>
        <div className={styles.dflex}>
          {isFullAccess && (
            <>
              <button
                className={`${styles.tabButton} ${activeTab === "received" ? styles.activeTab : ""}`}
                onClick={() => setActiveTab("received")}
              >
                Sales Bills & Sell              </button>
              <button
                className={`${styles.tabButton} ${activeTab === "payable" ? styles.activeTab : ""}`}
                onClick={() => setActiveTab("payable")}
              >
                Purchase Bills & Pay              </button>
            </>
          )}



          {isFullAccess && (
            <>

              <button
                className={`${styles.tabButton} ${activeTab === "transport" ? styles.activeTab : ""}`}
                onClick={() => setActiveTab("transport")}
              >
                Transport & Handler Bills              </button>

            </>
          )}

          {isFullAccess && (
            <>

              <button
                className={`${styles.tabButton} ${activeTab === "Asset" ? styles.activeTab : ""}`}
                onClick={() => setActiveTab("Asset")}
              >
                Box & Sack Ledger              </button>

            </>
          )}
          {/* Always show My Billing */}
          <button
            className={`${styles.tabButton} ${activeTab === "mybilling" ? styles.activeTab : ""}`}
            onClick={() => setActiveTab("mybilling")}
          >
            My Bills
          </button>
        </div>

        <div>
          <div className={styles.statsHeader}>
            <button
              className={styles.collapseBtn}
              onClick={() => setShowStats((prev) => !prev)}
            >
              {showStats ? (
                <FaChevronUp className={styles.collapseBtnicon} />
              ) : (
                <FaChevronDown className={styles.collapseBtnicon} />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      {showStats && (
        <div className={styles.summarySection}>
          {activeTab === 'payable' && (
            <>
              <div className={styles.summaryBox}>
                <h4 className={styles.margin}>Total Purchase Bills</h4>
                <h2 className={styles.marginnum}>
                  {payableData?.totalCount || 0}
                </h2>
                {/* <p className={styles.marginday}>Current Month</p> */}
              </div>
              <div className={styles.summaryBoxs}>
                <h4 className={styles.margin}>Total Purchase Amount</h4>
                <h2 className={styles.marginnum}>
                  {payableData?.totalPaidAmount || 0}
                </h2>
                <p className={styles.marginday}>Current Month</p>
              </div>
              <div className={styles.summaryBoxss}>
                <h4 className={styles.margin}>Outstanding Amounts</h4>
                <h2 className={styles.marginnum}>
                  {payableData?.totalUnpaidAmount || 0}
                </h2>
                <p className={styles.marginday}>Current Month</p>
              </div>
            </>
          )}

          {activeTab === 'received' && (
            <>
              <div className={styles.summaryBox}>
                <h4 className={styles.margin}>Total Sales Bills</h4>
                <h2 className={styles.marginnum}>{receivedStats.total}</h2>
                <p className={styles.marginday}>Current Month</p>
              </div>
              <div className={styles.summaryBoxs}>
                <h4 className={styles.margin}>Total Receivable Sales Bills</h4>
                <h2 className={styles.marginnum}>
                  {receivedStats.totalReceivedAmount}
                </h2>
                <p className={styles.marginday}>Current Month</p>
              </div>
              <div className={styles.summaryBoxss}>
                <h4 className={styles.margin}>Pending Sales Bills </h4>
                <h2 className={styles.marginnum}>
                  {receivedStats.totalPendingAmount}
                </h2>
                <p className={styles.marginday}>Current Month</p>
              </div>
            </>
          )}



          {activeTab === 'mybilling' && (
            <>
              <div className={styles.summaryBox}>
                <h4 className={styles.margin}>My Total Bills</h4>
                <h2 className={styles.marginnum}>{myBillingStats.totalBills}</h2>
                <p className={styles.marginday}>Current Month</p>
              </div>
              <div className={styles.summaryBoxs}>
                <h4 className={styles.margin}>My Paid Bills Counts</h4>
                <h2 className={styles.marginnum}>{myBillingStats.collected}</h2>
                <p className={styles.marginday}>Current Month</p>
              </div>
              <div className={styles.summaryBoxss}>
                <h4 className={styles.margin}>Remaining Balance</h4>
                <h2 className={styles.marginnum}>{myBillingStats.remaining}</h2>
                <p className={styles.marginday}>Current Month</p>
              </div>
            </>
          )}

        </div>
      )}


      {/* Conditional Tab Content */}
      {activeTab === 'payable' && isFullAccess && (
        <>
          {/* Filters */}
          <div className={styles.filterBar}>
            <input
              type="text"
              placeholder="Search..."
              className={styles.searchInput}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <select
              className={styles.inputs}
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <option value="">Payment Method</option>
              <option value="cash">Cash</option>
              <option value="upi">UPI</option>
              <option value="credit">credit</option>
            </select>
            <select
              className={styles.inputs}
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="paid">Paid</option>
              <option value="pending">Pending</option>
            </select>
            <DatePicker
              selected={fromDate}
              onChange={(date) => setFromDate(date)}
              dateFormat="dd.MM.yyyy"
              placeholderText="From Date"
              maxDate={new Date()}
              isClearable
              className={styles.inputss}
            />
            <DatePicker
              selected={toDate}
              onChange={(date) => setToDate(date)}
              dateFormat="dd.MM.yyyy"
              placeholderText="To Date"
              maxDate={new Date()}
              isClearable
              className={styles.inputss}
            />
            <button className={styles.clearBtn} onClick={clearFilters}>
              Clear All
            </button>
          </div>

          {/* Table */}
          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th>Receipt ID</th>
                  <th>Invoice ID</th>
                  <th>Receipt Owner</th>
                  <th>Phone Number</th>
                  <th>Org Name</th>
                  <th>Created Date</th>
                  <th>Amount</th>
                  <th>Payment Method</th>
                  <th>Billing  Status</th>
                  <th>Payment Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="7">Loading...</td>
                  </tr>
                ) : payableData?.data?.length ? (
                  payableData.data.map((item, idx) => (
                    <tr key={idx}>
                      <td >{item.receiptNo}</td>
                      <td className="notranslate">{item?.invoiceId?.invoiceNumber || '-'}</td>
                      <td>{item?.customerId?.firstName ? capitalize(item.customerId.firstName) : '-'}</td>
                      <td>{item?.customerId?.phone || '-'}</td>
                      <td>{item?.customerId?.storeName ? capitalize(item.customerId.storeName) : "-"}</td>
                      <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                      <td>₹ {item.totalAmount || 0}</td>
                      <td>{item.paymentMethod ? capitalize(item.paymentMethod) : '-'}</td>
                      <td>
                        <span
                          className={`${styles.status} ${item.billingStatus?.toLowerCase() === 'completed'
                            ? styles.paid
                            : styles.unpaid
                            }`}
                        >
                          {item.billingStatus || '-'}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`${styles.status} ${item.paymentStatus?.toLowerCase() === 'paid'
                            ? styles.paid
                            : styles.unpaid
                            }`}
                        >
                          {item.paymentStatus || 'Unknown'}
                        </span>
                      </td>
                      <td>
                        <div className={styles.actions}>
                          {item?.billingStatus !== "completed" && (
                            <button
                              className={styles.saveBtn}
                              // onClick={() =>
                              //   navigate("/dashboard/calculate", { state: { id: item._id, mode: "update" } })
                              // }
                              onClick={() =>
                                navigate("/dashboard/calculate", { state: { id: item._id, mode: "update", activeTab } })
                              }

                            >
                              Calculate Bill
                            </button>
                          )}
                          <FaEye
                            className={styles.icon}
                            //  onClick={() => navigate("/dashboard/calculate", { state: { id: item._id, mode: "view" } })}
                            onClick={() =>
                              navigate("/dashboard/calculate", { state: { id: item._id, mode: "view", activeTab } })
                            }

                          />
                          {item.billingStatus === 'completed' && (
                            <FaPrint
                              className={styles.icon}
                              onClick={() => {
                                setSelectedBill(item);
                                setShowPrintPopup(true);
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className={styles.noData} colSpan="7">No records found</td>
                  </tr>
                )}
              </tbody>

            </table>
          </div>
          <div className={styles.amountdiv}>
            <p >Total purchase received amount: ₹ {payableData?.totalpaidAmount}</p>
            <p>Total purchase pending amount: ₹ {payableData?.totalNotPaidAmount}</p>
          </div>
          {/* Pagination */}
          <div className={styles.paginationWrapper}>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
            <select
              className={styles.inputsbtn}
              value={limit}
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={10}>10 rows</option>
              <option value={25}>25 rows</option>
              <option value={50}>50 rows</option>
            </select>
          </div>
        </>
      )}

      {activeTab === 'received' && isFullAccess && (
        <ReceivedBills onStatsUpdate={setReceivedStats} />
      )}

      {activeTab === 'mybilling' && (
        <MyBilling onStatsUpdate={setMyBillingStats} />
      )}

      {activeTab === "transport" && isFullAccess && (
        <TransportHandlersBilling />
      )}

      {activeTab === "Asset" && isFullAccess && (
        <AssetTable />
      )}



      {showPrintPopup && selectedBill && (
        <PopupWrapper onClose={() => setShowPrintPopup(false)}>
          <div className={styles.popupHeader}>
            <div className={styles.header}>

              <h2 className={styles.tittle}>Share</h2>
              <span className={styles.closeIcon} onClick={() => setShowPrintPopup(false)}>
                ✕
              </span>
            </div>

            {/* Tab Buttons */}
            <div className={styles.tabHeader}>
              <button
                className={activeTabs === "thermal" ? styles.activeTabs : ""}
                onClick={() => setActiveTabs("thermal")}
              >
                Thermal Print
              </button>
              <button
                className={activeTabs === "whatsapp" ? styles.activeTabs : ""}
                onClick={() => setActiveTabs("whatsapp")}
              >
                WhatsApp Share
              </button>
            </div>


            {/* Tab Content */}
            <div className={styles.tabContent}>
              {activeTabs === "thermal" && (
                <div className={styles.invoicePreview}>
                  <PayableInvoiceDesign
                    mode="thermal"
                    data={selectedBill}
                  />
                </div>
              )}

              {activeTabs === "whatsapp" && (
                <div className={styles.whatsappShare}>
                  <PayableInvoiceDesign
                    mode="whatsapp"
                    data={selectedBill}
                  />
                </div>
              )}
            </div>

          </div>
        </PopupWrapper>
      )}
    </div>
  );
};

export default Billing;
